import PigGroupMigrationPanel from './PigGroupMigrationPanel';

export default PigGroupMigrationPanel;
